export const MetricTypes = {
  IMPRESSIONS: "impressions",
  CLICKS: "clicks",
  CTR: "ctr",
  COMMENTS: "comments",
  REACTIONS: "reactions",
  SHARES: "shares"
};
